import './Upload.css';
import { Component } from 'react';
import { Flow } from 'flow-react';
import { observer } from "mobx-react";
import Uppy from '@uppy/core';
// import XHRUpload from '@uppy/xhr-upload'
import { Dashboard } from '@uppy/react';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import Tus from '@uppy/tus';

const Upload = observer(
  class Upload extends Component {
		state = {
				files: [],
				progress: 0,
				progressmess: '',
				isuploading:false
		};
		uppy = false	
			
		constructor(props)  {
			super(props);
			this.uppy = new Uppy({ debug: true, autoProceed: false, hidePauseResumeButton: true });
			this.uppy.use(Tus, {
				// endpoint: 'https://vifogra.de/f2ul/index.php',
				// endpoint: 'http://vifogra.flowcenter.de/flapi/upload',
				// endpoint: 'https://vifogra.flowcenter.de/tusupload',
				endpoint: 'https://vifogra.de/tusupload',
				// endpoint: 'http://localhost:3000/tusupload/',
				formData: true,
				limit:1,
				allowedMetaFields: ['filename','reporter','prid','ua'],
				
			})
				
			this.uppy.on('file-added', (file) =>{
				console.log(file);
				this.uppy.setFileMeta(file.id, {
					filename: file.name,
					reporter: this.props.userid,
					prid: this.props.article.getId(),
					ua:navigator.userAgent,
				})
			})
			
			this.uppy.on('upload-success', (file, response) => {
				console.log('************************************************** upload-success ************************************************');
				console.log(file);
				console.log(response);
			})
			
			this.uppy.on('upload-error', (file, error, response) => {
				this.props.setHeaderMess("Fehler beim Dateiupload von Datei: "+file.name+"!\nBitte laden Sie den Uploder neu.");
				console.log('error message:', error);
				console.log(response);
				this.uppy.cancelAll()
			})
		}
			
			
		

		// ******** GEOLocation
		getGeoCoords = () => {
			var options = {
				enableHighAccuracy: true,
				timeout: 5000,
				maximumAge: 0
			};
			navigator.geolocation.getCurrentPosition(this.geoSuccess, this.geoError, options);
		}
		geoSuccess = (pos) => {
			let geoc = pos.coords.latitude.toFixed(5) + ',' + pos.coords.longitude.toFixed(5);
			if(window.confirm('Möchten Sie die Koordinaten mit der derzeitigen Position überschreiben?'))
				this.props.flow.editDistproject(this.props.article.getId(),{"geocoords":geoc})
			.then(res=>this.postGeoSave(res));
			document.getElementById('uploadgeocoords').innerHTML = geoc;
		}
		geoError = (err) => {
			alert('Koordinaten nicht verfügbar');
			this.setState({geocoords : false});
		}		
		postGeoSave = () => {
			this.props.flow.cccmylog('Upload -> postGeoSave ');
			alert("Die Koordinaten wurden gespeichert");
		}
			
		// ******** Artikel abschließen			
		closeart = () => {
			this.props.flow.cccmylog('Upload -> closeart ');
			if(window.confirm('Möchten Sie den Artikel abschließen?')) {
				let ws = this.props.article.getMetadata().get('workstatus');
				if(typeof(ws) == 'string')
					ws = ws.split(';');
				else
					ws = [];
				ws.push(this.props.userid);
				ws = ws.join(';');
				this.props.flow.editDistproject(this.props.article.getId(),{"workstatus":ws})
			    .then(res=>this.postcloseart(res));
			}
		}
		postcloseart = () => {
			this.props.flow.cccmylog('Upload -> postcloseart ');
			this.props.cbartsearchclicked();
		}
		
		// ******** Notiz speichern					
		savenote = () => {
			this.props.flow.cccmylog('Upload -> savenote ');
			this.props.flow.editDistproject(this.props.article.getId(),{"uploadernote":document.getElementById('editnotearea').value})
				.then(res=>this.postsavenote(res));
		}
		postsavenote = () => {
			this.props.flow.cccmylog('Upload -> postsavenote ');
			alert("Die Notiz wurde gespeichert");
		}
			
		optranslate = (op) => {
			if(op == '' || op == null)
				return 'nicht gesetzt';
			if(op == 'private')
				return 'Redaktion';
			if(op == 'public')
				return 'Öffentlich';
			if(op == 'members')
				return 'Kunden';
			if(op == 'publicguests')
				return 'Rettungskräfte';
		}


		render() {
				let ulnote = this.props.article.getMetadata().get('uploadernote') || '';
				return (
						<div className="uploadcont">
							<Dashboard uppy={this.uppy} hidePauseResumeButton={true}/>
							<div className="articlemetadatacont">
								<div className="metadatarow">
									<div className="metalabel">Notiz </div>
									<div className="metavalue">
										<textarea defaultValue={ulnote} id="editnotearea"></textarea>
										<br />
										<button className="red knob savenote" onClick={ this.savenote }>Speichern</button>
									</div>
								</div>
								<div className="metadatarow">
									<div className="metalabel">Erstellt durch: </div>
									<div className="metavalue">{this.props.ownermail}</div>
								</div>
								<div className="metadatarow">
									<div className="metalabel">Publishstatus: </div>
									<div className="metavalue">{this.optranslate( this.props.article.getMetadata().get('publishstatus'))}</div>
								</div>
								<div className="metadatarow">
									<div className="metalabel">Erstellt: </div>
									<div className="metavalue">{this.props.article.getMetadata().get('created')}</div>
								</div>
								<div className="metadatarow">
									<div className="metalabel">Koordinaten: </div>
									<div id="uploadgeocoords" className="metavalue">{this.props.article.getMetadata().get('geocoords')}</div>
									<div className="metavalue resetgeo"><button className="red knob resetgeocoods" onClick={ this.getGeoCoords }>setzen</button></div>
								</div>
								<div className="metadatarow">
									<div className="metalabel">  </div>
									<div className="metavalue"><button className="red knob closeart" onClick={ this.closeart }>Einsatz beenden</button></div>
								</div>
							</div>
						</div>
							
				);
		}
			
  }
);


export default Flow.injectFlow(Upload);
